module.exports = __webpack_public_path__ + "static/img/凤鸣腾飞.31729cf3.png";